import { reactive } from 'vue';
import Vue from "vue";

const device = Vue.observable({
    value: 'unknown', // 'mobile' | 'tablet' | 'desktop' | 'unknown'
    isMobile: false,
    size: 'unknown',
});
function detectUA() {
    try {
        const uaData = navigator.userAgentData;
        if (uaData && uaData.mobile !== undefined) {
            device.value = uaData.mobile ? 'phone' : 'desktop';
            device.isMobile = uaData.mobile;
            return;
        }

        const ua = navigator.userAgent || '';
        const isTablet = /iPad|Tablet|Tab|PlayBook|Silk|Kindle|Nexus 7|Nexus 9|SM-T|GT-P/i.test(ua);
        const isPhone = /Mobi|Android.+Mobile|iPhone|BlackBerry|Opera Mini|IEMobile/i.test(ua);

        if (isTablet) device.value = 'tablet';
        else if (isPhone) device.value = 'phone';
        else device.value = 'desktop';
        device.isMobile = isTablet || isPhone;
    } catch {
        device.value = 'unknown';
    }
}

function touchAndSizeHeuristics() {
    const hasTouch = navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
    const coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const smallWidth = window.innerWidth <= 820; // tamanho de tablet/mobile comum
    device.size = window.innerWidth;

    if (device.value === 'desktop') {
        if ((hasTouch || coarsePointer) && smallWidth) device.value = 'tablet';
    } else if (device.value === 'unknown') {
        if (hasTouch || coarsePointer || smallWidth) device.value = 'phone';
    }

    device.isMobile = hasTouch || coarsePointer;
}

detectUA();
touchAndSizeHeuristics();

// atualiza ao redimensionar/ alterar orientação
window.addEventListener('resize', touchAndSizeHeuristics);

export function useDevice() {
    return device;
}

export { device };
